/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiProblem,
  CreateInstallationRequest,
  InputValidationProblem,
  Installation,
  PatchObjectConfigContentRequest,
  UpdateInstallationRequest,
} from '../models';
import {
    ApiProblemFromJSON,
    ApiProblemToJSON,
    CreateInstallationRequestFromJSON,
    CreateInstallationRequestToJSON,
    InputValidationProblemFromJSON,
    InputValidationProblemToJSON,
    InstallationFromJSON,
    InstallationToJSON,
    PatchObjectConfigContentRequestFromJSON,
    PatchObjectConfigContentRequestToJSON,
    UpdateInstallationRequestFromJSON,
    UpdateInstallationRequestToJSON,
} from '../models';

export interface CreateInstallationOperationRequest {
    projectIdOrName: string;
    integrationId: string;
    installation: CreateInstallationRequest;
    skipSampling?: boolean;
}

export interface DeleteInstallationRequest {
    projectIdOrName: string;
    integrationId: string;
    installationId: string;
}

export interface GetInstallationRequest {
    projectIdOrName: string;
    integrationId: string;
    installationId: string;
}

export interface ListInstallationsRequest {
    projectIdOrName: string;
    integrationId: string;
    groupRef?: string;
}

export interface ListInstallationsForProjectRequest {
    projectIdOrName: string;
    groupRef?: string;
}

export interface PatchObjectConfigContentOperationRequest {
    projectIdOrName: string;
    integrationId: string;
    objectName: string;
    patchObjectConfigContent: PatchObjectConfigContentRequest;
}

export interface UpdateInstallationOperationRequest {
    projectIdOrName: string;
    integrationId: string;
    installationId: string;
    installationUpdate: UpdateInstallationRequest;
    skipSampling?: boolean;
}

/**
 * InstallationApi - interface
 * 
 * @export
 * @interface InstallationApiInterface
 */
export interface InstallationApiInterface {
    /**
     * Install an integration for a specific group. The group must already have a SaaS connection — either provide its `connectionId`, or omit it to use the group\'s default. To create a connection, use the [OAuth Connect endpoint](https://docs.ampersand.ai/reference/oauth/generate-oauth-authorization-url) or the [prebuilt UI components](https://docs.ampersand.ai/embeddable-ui-components). 
     * @summary Create a new installation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The integration ID.
     * @param {CreateInstallationRequest} installation 
     * @param {boolean} [skipSampling] When &#x60;true&#x60;, skips the sample read that validates the installation\&#39;s read configuration against the provider before saving. Defaults to &#x60;false&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    createInstallationRaw(requestParameters: CreateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>>;

    /**
     * Install an integration for a specific group. The group must already have a SaaS connection — either provide its `connectionId`, or omit it to use the group\'s default. To create a connection, use the [OAuth Connect endpoint](https://docs.ampersand.ai/reference/oauth/generate-oauth-authorization-url) or the [prebuilt UI components](https://docs.ampersand.ai/embeddable-ui-components). 
     * Create a new installation
     */
    createInstallation(requestParameters: CreateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation>;

    /**
     * Delete an Installation. This will also delete the associated Connection if it is not used by any other Installations. 
     * @summary Delete an installation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The integration ID.
     * @param {string} installationId The Ampersand installation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    deleteInstallationRaw(requestParameters: DeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete an Installation. This will also delete the associated Connection if it is not used by any other Installations. 
     * Delete an installation
     */
    deleteInstallation(requestParameters: DeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a single installation by ID, including its connection details, config, and health status. 
     * @summary Get an installation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The unique identifier (UUID) of the integration.
     * @param {string} installationId The unique identifier (UUID) of the installation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    getInstallationRaw(requestParameters: GetInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>>;

    /**
     * Retrieves a single installation by ID, including its connection details, config, and health status. 
     * Get an installation
     */
    getInstallation(requestParameters: GetInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation>;

    /**
     * Lists all installations for a specific integration within a project. To list installations across all integrations, use listInstallationsForProject instead. 
     * @summary List installations for an integration
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The unique identifier (UUID) of the integration.
     * @param {string} [groupRef] The ID that your app uses to identify a group of users (e.g. an org ID, workspace ID, or team ID). When provided, only returns installations belonging to this group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    listInstallationsRaw(requestParameters: ListInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Installation>>>;

    /**
     * Lists all installations for a specific integration within a project. To list installations across all integrations, use listInstallationsForProject instead. 
     * List installations for an integration
     */
    listInstallations(requestParameters: ListInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Installation>>;

    /**
     * Lists all installations across every integration in a project, giving you a complete view of all active customer integrations. To narrow results to a single integration, use listInstallations instead. 
     * @summary List installations for a project
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} [groupRef] The ID that your app uses to identify a group of users (e.g. an org ID, workspace ID, or team ID). When provided, only returns installations belonging to this group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    listInstallationsForProjectRaw(requestParameters: ListInstallationsForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Installation>>>;

    /**
     * Lists all installations across every integration in a project, giving you a complete view of all active customer integrations. To narrow results to a single integration, use listInstallations instead. 
     * List installations for a project
     */
    listInstallationsForProject(requestParameters: ListInstallationsForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Installation>>;

    /**
     * Updates a single object\'s configuration within an installation using JSON Patch syntax. 
     * @summary Update an installation object
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The integration ID.
     * @param {string} objectName The object name whose config content will be patched. Must match an object name defined in the integration\&#39;s manifest for the specified action type (read, subscribe, or write). Common examples include: &#x60;account&#x60;, &#x60;contact&#x60;, &#x60;lead&#x60;, &#x60;opportunity&#x60; (for Salesforce), &#x60;deal&#x60;, &#x60;company&#x60; (for HubSpot), etc. 
     * @param {PatchObjectConfigContentRequest} patchObjectConfigContent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    patchObjectConfigContentRaw(requestParameters: PatchObjectConfigContentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>>;

    /**
     * Updates a single object\'s configuration within an installation using JSON Patch syntax. 
     * Update an installation object
     */
    patchObjectConfigContent(requestParameters: PatchObjectConfigContentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation>;

    /**
     * Update an installation using field masks. Note: subscribe config changes trigger a subscription change in the provider\'s system, which typically takes 1-2 minutes but may take up to 10 minutes. 
     * @summary Update an installation
     * @param {string} projectIdOrName The Ampersand project ID or project name.
     * @param {string} integrationId The ID of the integration that this installation belongs to.
     * @param {string} installationId The Ampersand installation ID.
     * @param {UpdateInstallationRequest} installationUpdate 
     * @param {boolean} [skipSampling] When &#x60;true&#x60;, skips the sample read that validates the installation\&#39;s read configuration against the provider before saving. Defaults to &#x60;false&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallationApiInterface
     */
    updateInstallationRaw(requestParameters: UpdateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>>;

    /**
     * Update an installation using field masks. Note: subscribe config changes trigger a subscription change in the provider\'s system, which typically takes 1-2 minutes but may take up to 10 minutes. 
     * Update an installation
     */
    updateInstallation(requestParameters: UpdateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation>;

}

/**
 * 
 */
export class InstallationApi extends runtime.BaseAPI implements InstallationApiInterface {

    /**
     * Install an integration for a specific group. The group must already have a SaaS connection — either provide its `connectionId`, or omit it to use the group\'s default. To create a connection, use the [OAuth Connect endpoint](https://docs.ampersand.ai/reference/oauth/generate-oauth-authorization-url) or the [prebuilt UI components](https://docs.ampersand.ai/embeddable-ui-components). 
     * Create a new installation
     */
    async createInstallationRaw(requestParameters: CreateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling createInstallation.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling createInstallation.');
        }

        if (requestParameters.installation === null || requestParameters.installation === undefined) {
            throw new runtime.RequiredError('installation','Required parameter requestParameters.installation was null or undefined when calling createInstallation.');
        }

        const queryParameters: any = {};

        if (requestParameters.skipSampling !== undefined) {
            queryParameters['skipSampling'] = requestParameters.skipSampling;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInstallationRequestToJSON(requestParameters.installation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationFromJSON(jsonValue));
    }

    /**
     * Install an integration for a specific group. The group must already have a SaaS connection — either provide its `connectionId`, or omit it to use the group\'s default. To create a connection, use the [OAuth Connect endpoint](https://docs.ampersand.ai/reference/oauth/generate-oauth-authorization-url) or the [prebuilt UI components](https://docs.ampersand.ai/embeddable-ui-components). 
     * Create a new installation
     */
    async createInstallation(requestParameters: CreateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation> {
        const response = await this.createInstallationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an Installation. This will also delete the associated Connection if it is not used by any other Installations. 
     * Delete an installation
     */
    async deleteInstallationRaw(requestParameters: DeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling deleteInstallation.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling deleteInstallation.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling deleteInstallation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations/{installationId}`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an Installation. This will also delete the associated Connection if it is not used by any other Installations. 
     * Delete an installation
     */
    async deleteInstallation(requestParameters: DeleteInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteInstallationRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a single installation by ID, including its connection details, config, and health status. 
     * Get an installation
     */
    async getInstallationRaw(requestParameters: GetInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling getInstallation.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling getInstallation.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling getInstallation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations/{installationId}`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationFromJSON(jsonValue));
    }

    /**
     * Retrieves a single installation by ID, including its connection details, config, and health status. 
     * Get an installation
     */
    async getInstallation(requestParameters: GetInstallationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation> {
        const response = await this.getInstallationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all installations for a specific integration within a project. To list installations across all integrations, use listInstallationsForProject instead. 
     * List installations for an integration
     */
    async listInstallationsRaw(requestParameters: ListInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Installation>>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling listInstallations.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling listInstallations.');
        }

        const queryParameters: any = {};

        if (requestParameters.groupRef !== undefined) {
            queryParameters['groupRef'] = requestParameters.groupRef;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstallationFromJSON));
    }

    /**
     * Lists all installations for a specific integration within a project. To list installations across all integrations, use listInstallationsForProject instead. 
     * List installations for an integration
     */
    async listInstallations(requestParameters: ListInstallationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Installation>> {
        const response = await this.listInstallationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all installations across every integration in a project, giving you a complete view of all active customer integrations. To narrow results to a single integration, use listInstallations instead. 
     * List installations for a project
     */
    async listInstallationsForProjectRaw(requestParameters: ListInstallationsForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Installation>>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling listInstallationsForProject.');
        }

        const queryParameters: any = {};

        if (requestParameters.groupRef !== undefined) {
            queryParameters['groupRef'] = requestParameters.groupRef;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/installations`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstallationFromJSON));
    }

    /**
     * Lists all installations across every integration in a project, giving you a complete view of all active customer integrations. To narrow results to a single integration, use listInstallations instead. 
     * List installations for a project
     */
    async listInstallationsForProject(requestParameters: ListInstallationsForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Installation>> {
        const response = await this.listInstallationsForProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a single object\'s configuration within an installation using JSON Patch syntax. 
     * Update an installation object
     */
    async patchObjectConfigContentRaw(requestParameters: PatchObjectConfigContentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling patchObjectConfigContent.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling patchObjectConfigContent.');
        }

        if (requestParameters.objectName === null || requestParameters.objectName === undefined) {
            throw new runtime.RequiredError('objectName','Required parameter requestParameters.objectName was null or undefined when calling patchObjectConfigContent.');
        }

        if (requestParameters.patchObjectConfigContent === null || requestParameters.patchObjectConfigContent === undefined) {
            throw new runtime.RequiredError('patchObjectConfigContent','Required parameter requestParameters.patchObjectConfigContent was null or undefined when calling patchObjectConfigContent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/objects/{objectName}/config-content`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"objectName"}}`, encodeURIComponent(String(requestParameters.objectName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchObjectConfigContentRequestToJSON(requestParameters.patchObjectConfigContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationFromJSON(jsonValue));
    }

    /**
     * Updates a single object\'s configuration within an installation using JSON Patch syntax. 
     * Update an installation object
     */
    async patchObjectConfigContent(requestParameters: PatchObjectConfigContentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation> {
        const response = await this.patchObjectConfigContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an installation using field masks. Note: subscribe config changes trigger a subscription change in the provider\'s system, which typically takes 1-2 minutes but may take up to 10 minutes. 
     * Update an installation
     */
    async updateInstallationRaw(requestParameters: UpdateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Installation>> {
        if (requestParameters.projectIdOrName === null || requestParameters.projectIdOrName === undefined) {
            throw new runtime.RequiredError('projectIdOrName','Required parameter requestParameters.projectIdOrName was null or undefined when calling updateInstallation.');
        }

        if (requestParameters.integrationId === null || requestParameters.integrationId === undefined) {
            throw new runtime.RequiredError('integrationId','Required parameter requestParameters.integrationId was null or undefined when calling updateInstallation.');
        }

        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling updateInstallation.');
        }

        if (requestParameters.installationUpdate === null || requestParameters.installationUpdate === undefined) {
            throw new runtime.RequiredError('installationUpdate','Required parameter requestParameters.installationUpdate was null or undefined when calling updateInstallation.');
        }

        const queryParameters: any = {};

        if (requestParameters.skipSampling !== undefined) {
            queryParameters['skipSampling'] = requestParameters.skipSampling;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-Api-Key"] = this.configuration.apiKey("X-Api-Key"); // APIKeyHeader authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/projects/{projectIdOrName}/integrations/{integrationId}/installations/{installationId}`.replace(`{${"projectIdOrName"}}`, encodeURIComponent(String(requestParameters.projectIdOrName))).replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))).replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstallationRequestToJSON(requestParameters.installationUpdate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstallationFromJSON(jsonValue));
    }

    /**
     * Update an installation using field masks. Note: subscribe config changes trigger a subscription change in the provider\'s system, which typically takes 1-2 minutes but may take up to 10 minutes. 
     * Update an installation
     */
    async updateInstallation(requestParameters: UpdateInstallationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Installation> {
        const response = await this.updateInstallationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
